import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../../../components/Header/index'
import LoadingAbsolute from '../../../components/Loading/LoadingAbsolute'
import HistoryItem from './HistoryItem'
import SelectTesis from '../SelectTesis'
import axios from 'axios'
import Empty from '../../../components/Empty/Empty'

// const fakeData = [
//   {
//     id: 0,
//     title: 'Giriş',
//     guest_name: 'Parsel Sahibi',
//     date: '21.04.2025',
//   },
//   {
//     id: 1,
//     title: 'Misafir Girişi',
//     guest_name: 'Mehmet Karazor',
//     date: '21.04.2025',
//     giris_tipi: 'Araç', // [Araç, Yaya]
//     guest_count: 5,
//     number_plate: '42ST393',
//     tel: '05433902031',
//     durum: 'Giriş Yapıldı', // [Aktif, Giriş Yapıldı, İptal edildi, Süresi Doldu]
//     sms_durum: 'Başarısız', // [Başarısız, İletildi, Geçersiz Numara]
//   },
//   {
//     id: 2,
//     title: 'Giriş',
//     guest_name: 'Parsel Sahibi',
//     date: '21.04.2025',
//   },
//   {
//     id: 3,
//     title: 'Misafir Girişi',
//     guest_name: 'Mehmet Karazor',
//     date: '21.04.2025',
//     giris_tipi: 'Araç', // [Araç, Yaya]
//     guest_count: 5,
//     number_plate: '42ST393',
//     tel: '05433902031',
//     durum: 'Süresi Doldu', // [Aktif, Giriş Yapıldı, İptal edildi, Süresi Doldu]
//     sms_durum: 'Geçersiz Numara', // [Başarısız, İletildi, Geçersiz Numara]
//   },
// ]

const HistoryPage = () => {
  let location = useLocation()
  const navigate = useNavigate()
  const data = location?.state?.selectedTesis
  const [loading, setLoading] = useState(true)
  const [selectedTesis, setSelectedTesis] = useState(null)
  const [guestData, setGuestData] = useState([])

  useEffect(() => {
    if (data) {
      console.log('data: ', data)
      setLoading(false)
    }
    setSelectedTesis(data)

    const fetchGuestHistory = async () => {
      try {
        const res = await axios.get('https://app.yanibasimdakaratay.com/api/hobi-bahce/ziyaret-gecmisi', {
          headers: {
            Authorization: JSON.parse(localStorage.getItem('token')),
          },
        })
        console.log('res.data:', res.data)
        setGuestData(res.data.list)
      } catch (error) {
        console.error('Ziyaret gecmisi alinamadi:', error)
      }
    }

    fetchGuestHistory()
  }, [data])
  return (
    <>
      {loading ? <LoadingAbsolute formText={'Belgeleriniz yükleniyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={() => navigate('/hobiHome', { state: { selectedTesis: selectedTesis } })} rules={selectedTesis?.id === 2} />
        </div>
        <div className='container'>
          <SelectTesis data={selectedTesis} selectedItem={selectedTesis} />
          <div
            style={{
              textDecorationColor: '#205c42',
              textDecoration: 'underline',
              textUnderlineOffset: '8px',
              margin: '2rem 0 0 0',
            }}
          >
            Ziyaret Geçmişi
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '.8rem',
              margin: '1rem 0 3rem 0',
            }}
          >
            {guestData?.map((item) => (
              <HistoryItem key={item.id} item={item} />
            ))}
            {guestData?.length === 0 ? <Empty text='Bu tesisi daha önce hiç ziyaret etmediniz.' /> : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default HistoryPage
